/**
 * Extracted because jsdom doesn't implement this browser layout behavior, so tests can mock it.
 * in unit tests.
 */
export const setHeight = (textarea: HTMLTextAreaElement, height: number) => {
  textarea.style.height = `${height}px`;
};
